import styled from 'styled-components';

import { VFlex } from '@/components/base';
import Tooltip from '@/components/Tooltip/TooltipV2';
import Typo from '@/components/Typography/Typo';
import useMaxTaxonomyCount from '@/configs/useMaxTaxonomyCount';

type Props = {
  current: number;
};

const TaxonomyLimitGraph = (props: Props) => {
  const { maxTaxonomyCount } = useMaxTaxonomyCount();
  const maxCountMessage = `You can create up to ${maxTaxonomyCount} taxonomies`;

  return (
    <Tooltip tooltipNode={maxCountMessage}>
      <Style g={8}>
        <Typo>
          {props.current} / {maxTaxonomyCount} Taxonomies
        </Typo>
      </Style>
    </Tooltip>
  );
};

const Style = styled(VFlex)``;

export default TaxonomyLimitGraph;
